import API from './api';
import { Unit } from './units';

const BASE_URL = '2019-02-19/leasing/buildings/';

export interface Building {
  id: number;
  name: string;
  description: string;
  address: Location;
  units?: Unit[];
  image: string;
  amenities: Amenity[];
  services: Service[];
  type?: string;
  neighborhood_name?: string;
  neighborhood_description?: string;
  neighborhood_image?: string;
  building_group_id: number;
}

export interface Service {
  id: number;
  title: string;
  description: string;
  brief_description: string;
  image: string;
  icon: string;
}

export interface Location {
  address1: string;
  city: string;
  formatted_address?: string;
  geo?: { lat: number; lng: number };
  google_place_id?: string;
  postal_code: string;
  state: string;
  unit?: string;
}

export interface Amenity {
  id?: number;
  building_id: number;
  name: string;
  description?: string;
  image?: string;
  price?: string | null;
  capacity?: string | null;
  reservations_per_time_slot: number;
  minimum_reservation_time: string;
  maximum_reservation_time: string;
  start_time: string;
  end_time: string;
  booking_url?: string;
  created_at: string;
}

export interface StateCities {
  stateCode: string;
  state: string;
  cities: string[];
}

export interface BuildingsParams {
  limit?: number;
  offset?: number;
  city?: string;
  state?: string;
  name?: string;
}

export const getBuilding = async (id: number): Promise<Building> =>
  API.get(`${BASE_URL}${id}`).then(b => buildingMapper(b));

export const getServices = async (id: number): Promise<Service[]> =>
  API.get(`${BASE_URL}${id}/services`);

export const getCities = async (): Promise<StateCities[]> =>
  API.get(`${BASE_URL}/cities`);

export const getBuildings = async (
  params: BuildingsParams = {}
): Promise<Building[]> => {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach(
    ([key, value]) => value && urlParams.set(key, value)
  );
  return API.get(`${BASE_URL}?${urlParams}`).then(buildings => {
    return buildings.map((b: Building) => buildingMapper(b));
  });
};

const buildingMapper = (response: any): Building => ({
  ...response,
  address: { ...response.address, address: response.address.address1 },
});
